const CONTENT_TYPE = {
  FOLDER: 1, //文件夹
  LIBRARY: 2, //文本库
  SHARED_LIBRARY: 3, //共享文本库
  ANALYSIS: 4 //共享文本库
};
export { CONTENT_TYPE };
